export default "__VITE_ASSET__31494ed9__"